import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import Logged from './Logged';
import { useAppSelector, useAppDispatch } from '../../app/hooks';

import {
	selectLogged,
	selectIsAuthenticated,
} from '../auth/session/sessionSlice';

function ConditionalLogged() {
	let now = new Date();
	const session = useSelector(selectIsAuthenticated(now));
	if (session) {
		return (
			<Logged />
		)
	} else {
		return (
			<Link to={"/login"}>
				<Button sx={{ color: '#fff' }}>
					Login
				</Button>
			</Link>
		)
	}
}

function LoggedBar() {
	return (
		<Box>
			<Box sx={{ display: { xs: 'none', sm: 'block' } }}>
				<Link to={"/"}>
					<Button sx={{ color: '#fff' }}>
						Home
					</Button>
				</Link>
				<Link to={"/file/by/page"}>
					<Button sx={{ color: '#fff' }}>
						File
					</Button>
				</Link>
				<Link to={"/session/debug"}>
					<Button sx={{ color: '#fff' }}>
						Debug
					</Button>
				</Link>
				<Link to={"/profile"}>
					<Button sx={{ color: '#fff' }}>
						Profile
					</Button>
				</Link>
				<Logged />
			</Box>
		</Box>
	)
}

function NotLoggedBar() {
	return (
		<Box>
			<Box sx={{ display: { xs: 'none', sm: 'block' } }}>
				<Link to={"/"}>
					<Button sx={{ color: '#fff' }}>
						Home
					</Button>
				</Link>
				<Link to={"/login"}>
					<Button sx={{ color: '#fff' }}>
						Login
					</Button>
				</Link>
			</Box>
		</Box>
	)
}

function RightBox() {
	let now = new Date();
	const session = useSelector(selectIsAuthenticated(now));
	if (session) {
		return ( <LoggedBar /> )
	} else {
		return ( <NotLoggedBar /> )
	}
}

export default RightBox;
